// extracted by mini-css-extract-plugin
module.exports = {"container":"TopTabs_container__xFLFO"};